import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="421.137"
      height="1495.827"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 421.137 1495.827"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1058.192 -553.461)"
      >
        <path
          strokeWidth="1"
          d="M1069.82 620.679c8.16-10.493 25.04-10.095 36.71-10.485 26.46-.884 52.99 5.066 76.95 15.926"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1115.68 709.396s44.71 12.403 66.11 20.11c21.4 7.707 19.49 10.717 19.49 10.717"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1136.55 785.431s-11.31-5.448-13.26-10.734c-2.07-5.615-8.75-14.353-14.58-20.942-12.19-13.771-34.66-33.436-40.49-56.622-3.32-13.189-6.24-25.659-7.66-39.987-.5-5.035-1.46-11.3-.3-15.966 1.03-4.136 4.18-9.753 7.04-15.845 1.41-2.989.88-6.747 1.25-13.904.62-11.791.85-20.447.87-23.197.09-16.069 2.93-24.58 11.22-28.237 8.22-3.63 11-4.044 17.16-4.597 6.15-.553 20.03-.469 25.28-.34 9.36.229 19.15.655 28.95 3.197 16.29 4.22 33.05 14.093 49.07 22.968 5.77 3.197 11.08 6.762 16.58 9.427 2.93 1.42 52.57 20.152 56.84 22.072 15.7 7.062 29.78 7.554 38.02 12.81 2.58 1.642 8.46 5.114 11.26 9.502 2.7 4.239 2.36 9.387 3.24 11.525 2.41 5.895 3.69 3.17 4.78 7.007 1.08 3.838-1.92 4.95-.45 8.343 1.48 3.392 5.28 3.753 5.53 10.677.25 6.925-4.07 10.914-3.39 18.529 1.17 13.001 16.39 17.2 12.1 27.633-4.29 10.434-7.76 10.686-20.94 11.788-13.18 1.103-20.7-1.183-28.75-5.347-6.36-3.292-8.36-12.128-.35-13.074 7.49-.883 18.14 2.028 27.07-1.474 8.92-3.501 6.57-12.022 6.57-12.022"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1303.83 636.372s-3.51 2.732-6.79 6.48c-1.29 1.47.06 4.063-2.25 5.252-8.2 4.223-23.75-.119-23.73 5.158.04 10.981 34.91 13.56 34.91 13.56s-29.75-2.481-41.69-1.069c-4.07.481-4.29 7.486 2.55 11.448 7.19 4.159 23.33 7.381 33.93 9.901 8.92 2.119 13.06 3.885 13.06 3.885s-4.93 3.261-16.04 1.867c-11.11-1.394-26.18-9.247-29.36-5.01-1.19 1.58 1.07 6.697 6.41 10.375 8.98 6.182 23.69 11.379 23.69 11.379"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1294.26 631.046c-2.54 5.584-3.53 10.285-2.51 16.416"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1229.79 652.245c.71 1.936.08 5.409.98 7.077 1.95 3.605 5.56 5.874 6.3 9.958 2.92 16.197 11.76 23.267 21.58 33.738"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M1330.61 648.02l-.18-.127" opacity="1"></path>
        <path
          strokeWidth="1"
          d="M1329.58 647.563c11.97 1.127 23.57 4.637 34.18 10.423"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1137.09 886.71c.55 2.964 3.87 13.396 7.2 20.438 3.78 8.012 8.46 15.336 8.46 15.336l3.5.077s-.32-7.854-.27-16.019c.03-4.449.37-9.576.51-12.388"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1152.77 922.451c-.72-.398-6.16 2.269-10.26 5.045-4.11 2.776-8.45 7.198-11.53 12.795"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1134.99 953.995c2.86-5.505 11.75-14.096 16.82-15.891 14.4-5.095 32.49 2.849 45.23 3.332 18.08.686 30.97 2.29 48.63-2.151"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1156.3 922.542c6.21.353 23.68 7.164 29.88 7.725 19.37 1.752 25.08 3.628 42.67.394"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1106.3 1253.17c.56 6.9-.02 14.55 3.87 20.77 7.58 12.12 23.33 12.04 28.77 26.57-4.88 3.32-15.21 7.91-14.9 15.82.11 2.78 2.02 5.52 1.42 8.24-2.08 9.34-14.62 23.31-4.37 32.51 9.7 8.72 20.33 16.36 30.11 24.99 3.85 3.4-1.99 22.17 1.7 29.94 5.04 10.59 13.18 17.03 21.35 24.94"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1138.59 1301.05c-1.65 2.57-9.79 13.17-6.02 16.87 2.95 2.89 7.92-.71 9.43 4.1 2.04 6.48-6.21 12.07-9.38 18.08-5.49 10.42 12.24 23.06 17.59 27.74"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1122.84 1283.28c-.89-4.41-1.56-2.76.5-5.31 11.81 5.82 24.34 3.92 36.44-1.33 22.9-9.93 45.12-21.39 68.11-31.11 51.26-21.68 102.02-31.28 151.89-56.11"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1144.42 1313.18c13.71-3.47 27.69-5.99 41.11-10.42 21.97-7.23 42.74-17.89 64.91-24.49 30-8.94 61.51-12.39 91.3-22.02 19.52-6.32 33.22-14.97 51.89-23.51"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1203.81 1297.14c-10.09 28.89 6.33 46.18 36.05 43.45 35.3-3.25 74.08-6.34 107.85-16.5"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1201.34 1304.46c-9.77 29.54 1.79 40.44 34.36 40.92 33.57.5 63.61-1.4 96.45-8.21"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1334.85 1258.33c5.11 13 11.2 23.92 13.7 37.66 1.74 9.51-1.06 19.74-.2 29.39 1.32 14.95 7.37 30.71 7.06 45.69-1.47 71.42-9.4 142.6-11.14 214.02-.73 29.54-.05 59.26 3.73 88.56 6.5 50.4 14.94 100.67 27.05 150.02 2.59 10.56 12.89 17.85 16.63 28.06 10.96 29.93 18.72 58.6 27.8 89.16"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1346.88 1287.74c22.25-3.36 41.83-10.43 61.1-23.74"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1349.26 1299.01c19.71-4.09 45.8-10.93 62.12-23.53"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1217.35 1337.76c-1.03-7.45-2.71-29.65 1.92-31.5 4.64-1.84 69.96-13.87 76.44-12.98 2.92.4 4.25 27.34 4.75 40.6"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1225.68 1339.9c-.32-2.61-3.07-24.76.36-26.91 4.58-2.88 49.33-12.26 59.84-8.5 1.87.66 1.68 27.43 1.9 31.15"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1177.45 1444.48c3.2 11.12 2.98 22.96 4.44 34.44 2.35 18.44 5.93 36.7 9.33 54.97 11.71 62.79 24 125.46 36 188.2"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1172.9 1888.42c23.53 10.95 78.41 15.64 102.23 8.21"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1214.65 1983.34c23.99 6.12 63.01 13.65 79.94 4.4"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1231.72 1749.69c-1.47 5.11 4.06 16.96 5.8 21.76 4.12 11.3 6.76 22.22 11.81 33.29 4.82 10.53 14.98 18.79 21.64 27.6"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1258.11 1821.73c1.68 9.05-8.7 14.45-5.53 23.16 1.01 2.8 4.25 3.87 5.4 6.37 1.27 2.79-1.31 6.76.19 10.51 1.14 2.84 4.37 4.93 5.65 7.73 3.74 8.17 9.9 17.31 11.57 26.31 1.78 9.57 12.03 29.64 13.81 39.21"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1449.96 1931.98c-.26.19-18.58 8.51-44.56 12.91-27.72 4.68-63.95 5.5-88.81 7.02-10.36.64-20.42-16.53-25.57-14.26-10.72 4.74 1.96 42.79 11.61 68.26 7.79 20.56 17.02 32.28 23.6 36.73 24.96 16.92 138.17-24.07 138.17-24.07s6.32-3.12 9.61-12.75c2.14-6.27 2.95-14.79 2.8-23.27-.11-6.25-.61-12.56-2.15-17.54-2.41-7.83-7.76-12.91-15.36-21.9-3.31-3.92-7.8-7.11-10.89-15.76-10.36-29.02-10.51-42.15-20.36-76.34-4.28-14.85-10.53-26.71-13.12-36.77-3.34-13.05-.61-9.45-2.07-21.75s-1.92-9.41-3.75-25.73c-1.11-9.93-1.21-20.77-2.79-34.14-1.91-16.1-12.34-35.2-9.78-46.96 1.07-4.94 2.28-9.99 4.32-16.22 1.82-5.56 4.4-11.94 6.65-21.67 3.31-14.25 4.25-31.14 5.54-44.26 3.24-32.91 5.91-23.82 6.13-45.81.08-8.38-9.14-28-6.09-36.97 1.1-3.23 3.95-8.92 4.49-12.43.72-4.66-.37-6.38 3.13-10.35 4.83-5.49 4.42-5.08 5.91-8.02 4.8-9.45 6.99-23.72 7.83-35.91 2.81-41.13 1.93-84.16-6.1-116.34-3.39-13.62-4.43-36.43-11.19-44.6-3.58-4.33-5.4-16.68-5.4-16.68s-1.06-5.76-3.4-12.4c-1.84-5.21-4.72-10.81-6.72-15.64-4.54-10.99-4.9-5.77-8.07-15.91-5.09-16.26-13.48-43.13-13.48-43.13"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1261.26 1899.32c2.17 27.3 3.46 63.37-1.36 90.69"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1269.44 1898.54c2.62 27.17 3.86 65.8-2.8 92.44"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1253.26 1846.25c-.74 2.19.25 10.01.58 12.97.81 7.29-.64 15.04-.64 22.47 0 3.87-.32 7.64-.32 11.48 0 1.02-.41 3.9-.46 6.03"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1260.66 1865.55c-.12 1.31.19 6.88.19 9.13 0 5-.63 20.05-2.78 24.35"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1425.67 1325.14c-10.34 8.05-22.09 10.59-33.92 9.89"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1428.05 1337.44c-10.03 8.87-22.91 10.02-33.03 9.53"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1391.87 1335.21c13.25 53.02 25.37 105.89 21.19 160.86l6.29.1"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1119.18 903.455s23.42-27.076 53.16-42.966c29.74-15.89 65.8-20.594 65.8-20.594"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1146.02 880.797s9.46 18.712 40.04 30.56c51.66 20.019 74.5 34.701 102.85 58.638 26.3 22.201 52.13 42.235 62.97 59.165 11.1 17.32 6.91 31.28 6.91 31.28"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1272.48 697.959s-82.67 44.363-127.39 82.806c-6.12 5.253-17.1 6.972-21.35 10.926-4.46 4.16-4.52 6.724-2.34 10.053.77 1.182 2.84 1.956 3.68 3.633 1.26 2.499 1.08 5.068 2.77 7.3 1.87 2.453 2.99.631 8.12 5.765 1.98 1.975 1.93 5.903 3.52 8.47 1.72 2.797 9.64 6.558 9.64 6.558s-5.79 9.059-9.91 16.814c-1.68 3.157-1.7 6.839-2.46 10.552-.53 2.631-1.8 5.453-2.67 7.34-1.77 3.793-4.77 7.531-6.09 10.871-1.74 4.374-3.85 8.98-5.2 12.463-2.9 7.522-3.42 9.16-3.8 11.649"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1329.04 731.609s4.81 27.854 14.83 64.251c5.73 20.811 15.71 44.239 21.05 67.293 14.66 63.374 22.78 121.953 22.78 121.953"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1363.16 657.034s30.62 19.636 24.36 52.17c-12.17 63.173-44.8 78.77-44.8 78.77"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1363.13 656.02s22.13-6.759 39.58 6.897c6.66 5.211 9.23 4.015 15.7 12.3 7.7 9.848 16.94 21.936 23.83 36.463 3.35 7.08 7.62 12.196 10.29 20.043 7.77 22.816 11.12 50.637 10.89 74.744-.12 12.715-6.03 28.388-12.52 41.08-2.32 4.54-5.21 11.123-8.62 17.087-2.26 3.939-5.31 7.047-6.53 11.118-2.86 9.546-7.04 18.746-11.95 29.165-2.21 4.701-5.59 10.336-7.59 15.975-1.88 5.275-2.37 10.558-4.32 14.93-1.7 3.812-3.38 7.595-5.03 11.34-2.18 4.935-1.44 14.409-3.52 19.192-3.24 7.449-3.4 18.231-5.07 27.604-1.45 8.142-4.41 15.002-6.87 20.352-1.02 2.21-3.2 4.82-4.22 6.86-1.53 3.05-2.54 7.28-4.02 9.93-2.8 5-5.68 7.61-8.87 10.7-4.05 3.91-5.89 4.98-9.53 11.61-3.82 7-5.3 7.96-5.3 7.96"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1105.56 1253.48c-4.17 14.06.01 17.73-.61 31.11-.06 1.43-.3 2.98-1.03 4.13-2.04 3.21-2.66 6.31-2.44 10.28.13 2.43 1.34 4.94 2.21 7.5 1.93 5.68.28 4.87-.92 6.63-1.61 2.37-1.83 7.89-1.24 11.28 1.21 6.95 8.38 10.11 8.23 13.43-.26 5.87-3.5 7.25-4.68 14.12-1.63 9.47-1.59 7.84-2.41 26-.71 15.74-.38 37.6.46 62.52 1.01 30.11 4.91 67.07 9.92 101.5 3.86 26.48 7.12 54.8 10.81 78.06 4.64 29.18 10.38 51.53 11.82 71.64.28 3.93 4.82 25.38 5.98 28.42 1.61 4.21 3.57 10.34 5.66 14.06 1.72 3.04 3.81 5.86 5.99 8.94 1.06 1.47 3.38 3.16 3.97 5.25 2.37 8.41-2.41 16.6.31 27.62 2.73 11.02 8.63 11.85 9.8 15.14 2.95 8.28-2.43 10.49-.5 18.25 1.27 5.15 8.18 6.91 6.92 12.13-1.06 4.39-3.67 11.22-3.74 26.92-.05 9.78 2.04 20.39 3.1 27.2.63 4.12.11 12 .11 12"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1405.07 1348.34s8.13 36.42 11.98 71.69c3.85 35.26 3.42 69.37 3.42 69.37"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1118.83 904.743s-2.93 5.879.1 14.788c3.04 8.909 12.03 20.848 12.03 20.848l3.9 13.792"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1430.65 1940.45s9.97 18.26 14.82 38.08c4.85 19.82 4.18 44.13 4.18 44.13"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;